import Cookies from 'js-cookie'
import { getBackendUrl } from './url'

const COOKIE_NAME = 'auth_token'

export function getToken() {
	return Cookies.get(COOKIE_NAME) || null
}

export function setToken(token) {
	// expires: 365 so the cookie persists across browser sessions
	Cookies.set(COOKIE_NAME, token, { expires: 365, sameSite: 'Lax' })
}

export function clearToken() {
	Cookies.remove(COOKIE_NAME)
}

export function isAuthEnabled() {
	return window.__RUNTIME_CONFIG__?.REACT_APP_AUTH_ENABLED === 'true'
}

export function isAuthenticated() {
	if (!isAuthEnabled()) return true
	return !!getToken()
}

export async function validateKeyAndStore(key) {
	const backendUrl = getBackendUrl()
	const response = await fetch(`${backendUrl}/api/auth/validate`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ key }),
	})

	if (!response.ok) return false

	const data = await response.json()

	// Auth disabled server-side — no token needed
	if (data.authEnabled === false) return true

	if (data.token) {
		setToken(data.token)
		return true
	}

	return false
}
